import { z } from "zod"

const userNameSchema = z
  .string()
  .trim()
  .min(1, "User Name is required")
  .max(50, "User Name must be at most 50 characters")
  .regex(/^[^?#&/=%]+$/, "User Name cannot contain special characters ? # & / = %")

const organisationSchema = z.string().min(1, "Organisation is required")

export const AuditUserExclusionCreateSchema = z.object({
  action: z.literal("CREATE"),
  organisation: organisationSchema,
  userName: userNameSchema,
})

export const AuditUserExclusionDeleteSchema = z.object({
  action: z.literal("DELETE"),
  organisation: organisationSchema,
  userName: userNameSchema,
})

export const AuditUserExclusionDeleteAllSchema = z.object({
  action: z.literal("DELETE_ALL"),
  organisation: organisationSchema,
})

export const AuditUserExclusionSchema = z.discriminatedUnion("action", [
  AuditUserExclusionCreateSchema,
  AuditUserExclusionDeleteSchema,
  AuditUserExclusionDeleteAllSchema,
])

export type AuditUserExclusion = z.infer<typeof AuditUserExclusionSchema>
